<template>
  <div>
    <v-layout :class="justify ? 'justify-' + justify : ''">
      <h2 class="primary--text text-uppercase textoAjustado" :class="align ? 'text-' + align : ''"><slot></slot></h2>
    </v-layout>
    <v-divider v-if="divider" class="dividerTitle primary mb-3"/>
  </div>
</template>

<script>
export default {
  name: 'o-big-title',
  props: {
    align: {
      type: String,
      default: 'center'
    },
    justify: {
      type: String,
      default: 'center'
    },
    divider: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="sass" scoped>

.dividerTitle.v-divider
    border-width: 4px 0 0 0
    margin: 0px 0px

</style>

